import { render, staticRenderFns } from "./Template-Principal.vue?vue&type=template&id=524c794c&scoped=true&"
import script from "./Template-Principal.vue?vue&type=script&lang=js&"
export * from "./Template-Principal.vue?vue&type=script&lang=js&"
import style0 from "./Template-Principal.vue?vue&type=style&index=0&id=524c794c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c794c",
  null
  
)

export default component.exports